import { Loading } from '@vnetwork/datacentral-ui/feedback'

const LoadingBackdrop = () => {
    return <Loading fullscreen className="z-[var(--vn-z-popover)]" />
}

export default LoadingBackdrop
